// constants
import { showSuccessAlert } from "../../constants/alerts";
import { ReferelCodeActionTypes } from "./constants";

const INIT_STATE = {
  referelCodes: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface ReferelCodeActionType {
  type:
    | ReferelCodeActionTypes.API_RESPONSE_SUCCESS
    | ReferelCodeActionTypes.API_RESPONSE_ERROR
    | ReferelCodeActionTypes.ADD_REFERELCODE
    | ReferelCodeActionTypes.UPDATE_REFERELCODE;

  payload: {
    actionType?: string;
    data?: any;
    error?: string;
    message?: string;
  };
}

const ReferelCode = (state: any = INIT_STATE, action: ReferelCodeActionType): any => {
  switch (action.type) {
    // ✅ Common Success
    case ReferelCodeActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case ReferelCodeActionTypes.ADD_REFERELCODE:
        case ReferelCodeActionTypes.UPDATE_REFERELCODE:
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        default:
          return { ...state };
      }

    // ❌ Common Error
    case ReferelCodeActionTypes.API_RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        initialLoading: false,
      };

    // 🚀 Request Start
    case ReferelCodeActionTypes.ADD_REFERELCODE:
    case ReferelCodeActionTypes.UPDATE_REFERELCODE:
      return { ...state, loading: true, initialLoading: true };

    // Default
    default:
      return { ...state };
  }
};

export default ReferelCode;
